import type { SlotCode, UnitPosition, UnitBoardEntry } from './types'

/** Which unit positions may legally fill a roster slot. Mirrors slot_accepts() in SQL. */
export function slotAccepts(slot: SlotCode, pos: UnitPosition): boolean {
  if (slot === 'FLEX') return pos === 'RB' || pos === 'WR' || pos === 'TE'
  return slot === pos
}

/** A unit is pickable if it plays this week, hasn't kicked off, and isn't burned. */
export function isPickable(e: UnitBoardEntry): boolean {
  return !e.onBye && !e.locked && !e.burned
}

export function reasonUnavailable(e: UnitBoardEntry): string | null {
  if (e.burned) return `Burned in Week ${e.burnedWeekNo}`
  if (e.onBye) return 'Bye week'
  if (e.locked) return 'Kicked off'
  return null
}

/**
 * How many usable weeks a unit has left in the phase — the number that makes
 * the burn decision interesting. Bye weeks and already-passed weeks don't count.
 */
export function remainingWindows(
  currentWeek: number,
  lastWeek: number,
  byeWeeks: number[],
): number {
  let n = 0
  for (let w = currentWeek; w <= lastWeek; w++) {
    if (!byeWeeks.includes(w)) n++
  }
  return n
}

/** Scarcity: burning a unit with few windows left costs you less. */
export function burnCost(e: UnitBoardEntry, windowsLeft: number): number {
  const value = e.projected ?? e.seasonAvg ?? 0
  if (windowsLeft <= 0) return 0
  return Number((value / windowsLeft).toFixed(2))
}

export const POSITION_ORDER: UnitPosition[] = ['QB', 'RB', 'WR', 'TE', 'K', 'DEF']

export function slotLabel(slot: SlotCode): string {
  return slot === 'DEF' ? 'D/ST' : slot
}
